import { Injectable } from "@angular/core";
import { LoadingController, ToastController, Platform } from "ionic-angular";
import { TranslateService } from "@ngx-translate/core";
import { StatusBar } from "@ionic-native/status-bar";
@Injectable()
export class Wall {
  public loader: any;
  public content_text: any;
  public onDevice: boolean;
  constructor(
    public loadingCtrl: LoadingController,
    public toastCtrl: ToastController,
    public translateService: TranslateService,
    public statusBar: StatusBar,
    private platform: Platform
  ) {
    this.content_text = this.translate("PLEASE_WAIT");
    this.onDevice = this.platform.is('cordova');
  }

  barsLight() {
    if (this.onDevice) {
      console.log("On Device");
      // let status bar overlay webview
      this.statusBar.overlaysWebView(true);
      // set status bar to white
      this.statusBar.styleLightContent();
     // this.statusBar.backgroundColorByHexString('#211c54');
    }
  }

  barsDefault() {
    if (this.onDevice) {
      console.log("On Device Default");
      // let status bar overlay webview
      this.statusBar.overlaysWebView(true);
      // set status bar to white
      this.statusBar.styleDefault();
      //this.statusBar.backgroundColorByHexString('#333333');
    }
  }

  page(page) {
    let newPage = parseInt(page) + 1;
    return newPage.toString();
  }

  translate(key) {
    let newValue;
    this.translateService.get(key).subscribe(value => {
      newValue = value;
    });
    return newValue;
  }

  //Loader Message
  presentLoading() {
    // this.loader = this.loadingCtrl.create({ content: this.content_text });
    // this.loader.present();
  }

  closeLoading() {
    // this.loader.dismiss();
  }

  presentToast(msg) {
    let toast = this.toastCtrl.create({
      message: msg,
      duration: 3000,
      position: "bottom"
    });

    toast.onDidDismiss(() => {
     
    });

    toast.present();
  }

  back(dataSet) {
    //this.viewCtrl.dismiss(dataSet);
   
  }

  reactionClass(type) {
    return this.reactions(type) + "IconSmall";
  }

  reactions(type) {
    let A = "";
    if (parseInt(type) > 0) {
      if (parseInt(type) === 1) A = "like";
      else if (parseInt(type) === 2) A = "love";
      else if (parseInt(type) === 3) A = "haha";
      else if (parseInt(type) === 4) A = "wow";
      else if (parseInt(type) === 5) A = "cool";
      else if (parseInt(type) === 6) A = "confused";
      else if (parseInt(type) === 7) A = "sad";
      else if (parseInt(type) === 8) A = "angry";
    }
    return A;
  }

  imageName(uid, type ){
    const newTime = Math.floor(Date.now() / 1000);
    return type + uid + newTime+'.jpg';
    //return 'mypic.jpg';
  }
}



// WEBPACK FOOTER //
// ./src/providers/wall/wall.ts